import { AppProvider } from "providers/AppProvider";

import { AppRoutes } from "routes";
import "./i18n";

function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
